import React from 'react';

// Why does this component even exist?
// Blame the authors
// https://github.com/tannerlinsley/react-table/issues/1266#issuecomment-469303181
export default ({ filter, onChange }) => {
  const [focused, setFocused] = React.useState(false);
  return (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
      <svg
        style={{ position: 'absolute', left: '7px', pointerEvents: 'none', opacity: 0.35 }}
        width="11" height="11" viewBox="0 0 16 16" fill="none"
      >
        <circle cx="6.5" cy="6.5" r="5" stroke="#585969" strokeWidth="2" />
        <line x1="10.5" y1="10.5" x2="14" y2="14" stroke="#585969" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <input
        placeholder="Search"
        value={filter ? filter.value : ''}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          width: '100%',
          height: '30px',
          paddingLeft: '24px',
          paddingRight: '6px',
          fontSize: '11px',
          border: `1px solid ${focused ? '#6C5DD3' : '#E3E3E3'}`,
          borderRadius: '4px',
          background: focused ? '#FDFCFF' : '#FAFAFA',
          color: '#0F0B28',
          outline: 'none',
          transition: 'border-color 0.15s, background 0.15s',
        }}
      />
    </div>
  );
};
